<template>
  <!-- Seaded -> Kasutajad uues kujunduses: the new look. Off, the old form. -->
  <form-plate v-if="plate" />
  <loading-content v-else :loading="loading">
    <heading>
      <template v-if="formType === types.CREATE">Lisa uus kasutaja</template>
      <template v-else-if="user">{{user.fullName}}</template>
    </heading>
    <v-row>
      <v-col col="12" md="6" xl="4">
        <card>
          <v-form ref="observer" @submit.prevent>
            <v-text-field
              :rules="[rules.required]"
              v-model="form.firstName"
              label="Eesnimi"
              required
            />
            <v-text-field
              :rules="[rules.required]"
              v-model="form.lastName"
              label="Perenimi"
              required
            />
            <v-text-field
              :rules="[rules.required]"
              v-model="form.email"
              label="E-posti aadress"
              required
            />
            <v-text-field
              v-model="form.password"
              label="Password"
              type="password"
            />
            <v-text-field
              v-model="form.phone1"
              label="Telefon 1"
            />
            <v-text-field
              v-model="form.phone2"
              label="Telefon 2"
            />
            <v-menu v-model="menu" transition="scale-transition" min-width="290px">
              <template #activator="{ props }">
                <v-text-field v-model="form.color" label="Värv" v-bind="props" />
              </template>
              <v-card>
                <v-card-text class="pa-0">
                  <v-color-picker v-model="form.color" flat />
                </v-card-text>
              </v-card>
            </v-menu>
            <v-select
              v-model="form.roles"
              :items="roles"
              item-title="title"
              item-value="id"
              label="Rollid"
              multiple
              chips
            />
            <v-checkbox
              v-model="form.active"
              label="Aktiivne"
              type="checkbox"
            />
            <v-checkbox
              v-model="form.showInPlanner"
              label="Kuvatakse planeerijas"
              type="checkbox"
            />
            <v-btn :loading="submitLoading" color="success" @click="_submit()">Salvesta</v-btn>
          </v-form>
        </card>
        <passkeys-of v-if="id" kind="user" :owner-id="id" framed class="mt-4" />
      </v-col>
    </v-row>
  </loading-content>
</template>

<script>
import api from './../../api'
import formMixin from '@/plugins/formMixin'
import rules from '@/plugins/rules'
import { mapState } from 'vuex'
import FormPlate from './FormPlate.vue'
import PasskeysOf from '@/components/PasskeysOf.vue'

export default {
  components: { FormPlate, PasskeysOf },
  mixins: [ formMixin ],
  data () {
    return {
      rules,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        phone1: '',
        phone2: '',
        color: '#DDDDDD',
        roles: [],
        active: false,
        showInPlanner: false
      },
      menu: false,
      user: null,
      roles: []
    }
  },
  watch: {
    async id (id) {
      this.user = null
      if (!id) {
        return
      }
      const user = await api.getUser(id)
      this.user = user
      Object.assign(this.form, user, { roles: user.roles.map(({ id }) => id )})
    },
    'form.roles' (roles, previous) {
      // A newly-selected tehnic role defaults the user to visible in the planner
      // (mirrors migration 03, which backfilled show_in_planner for technicians),
      // so technicians created after that migration still appear. Create-only and
      // only when tehnic is freshly added, so the admin can still untick it and
      // editing an existing user never overrides the stored value.
      if (this.formType !== this.types.CREATE) {
        return
      }
      if (this.tehnicRoleId && roles.includes(this.tehnicRoleId) && !(previous || []).includes(this.tehnicRoleId)) {
        this.form.showInPlanner = true
      }
    }
  },
  computed: {
    ...mapState(['features']),
    plate () {
      return !!(this.features && this.features.userPlate)
    },
    tehnicRoleId () {
      const role = this.roles.find(({ title }) => title === 'tehnic')
      return role ? role.id : null
    },
    successMessage() {
      switch (this.formType) {
        case this.types.CREATE:
          return 'Uus kasutaja edukalt loodud'
        default:
          return 'Kasutaja edukalt uuendatud'
      }
    },
    swatchStyle() {
      const color = this.form.color
      const menu = this.menu

      return {
        backgroundColor: color,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out'
      }
    }
  },
  methods: {
    async handleForm () {
      if (this.formType === this.types.CREATE) {
        // POST /api/user answers { user }: taking the answer for the user sent
        // the page to /users/undefined.
        const { user } = await api.createUser(this.form)
        this.$router.push({ name: 'user', params: { userId: user.id }})
      } else {
        await api.updateUser(this.id, this.form)
      }
      return true
    }
  },
  mounted () {
    // The new look loads its own.
    if (this.plate) return
    this.id = this.$route.params.userId
    api.getRoles().then(({ roles }) => this.roles = roles)
  }
}
</script>